<template>
  <b-modal :id="idModal" class="modal-info" hide-footer size="sm" scrollable centered @hide="handleOfModal">
    <template v-slot:modal-header>
      <div class="modal-info__head modal-info__head--psmall display-flex-center justify-content-between full-width">
        <h4 class="modal-info__title font-sanpro-bold primary-color-txt">Chia sẻ</h4>
        <span @click="$bvModal.hide(idModal)" class="modal-info__close"><i class="icon-close"></i></span>
      </div>
    </template>
    <div class="modal-info__body primary-color-txt font-sanpro-light bg-color-light" :class="{'disabled': loading}">
      <div class="share-list">
        <!-- <a class="facebook epcl-button circle" rel="nofollow external noopener noreferrer" href="javascript:;" onclick="window.open(`https://www.facebook.com/sharer/sharer.php?u=${linkShare}`, 'facebook-share','width=580,height=296');return false;" data-wpel-link="external"><i class="fab fa-facebook-square"></i> Facebook</a> -->
        <a href="javascript:;" v-for="(item, index) of shareType" :key="index" class="item" @click="handleShareMedia(item.id)">
          <i v-if="item.id !== shareZalo" :class="item.icon"></i> 
          <span v-else class="icon-zalo font-size-22"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span></span>
          {{ item.name }}
        </a>
        <ModalShareEmail :linkShare="linkShare" />
      </div>
      <input type="text" id="link_share" v-model="linkShare">
    </div>
    <!-- <div id="fb-root"></div> -->
  </b-modal>
</template>
<!-- <script src="https://sp.zalo.me/plugins/sdk.js"></script> -->
<script>
  (function(d, s, id) {
  var js, fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s); js.id = id;
  js.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.0";
  fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));

  import { ID_MODAL_SHARE, ID_MODAL_SHARE_MAIL } from './../../_store/constants'
  import { mapState, mapActions } from 'vuex'
  import { EMAIL_PUBLIC } from '@/store/auth/constants'
  import { getAuth } from '@/utils/jwt'
  import ModalShareEmail from './ModalShareEmail.vue'
  import { saveLogShareSocial } from './../../_api/'

  export default {
    name: 'ModalShare',
    components: {
      ModalShareEmail
    },
    data () {
      return {
        idModal: ID_MODAL_SHARE,
        typeFace: 'facebook',
        typeMail: 'gmail',
        typeZalo: 'zalo',
        typeCopy: 'copy',
        linkShare: ''
      }
    },
    // metaInfo() {
    //   return {
    //     title: this.mediaShareInfo.titleLink,
    //     titleTemplate: 'Hành trang số',
    //     meta: [
    //       { name: 'description', content: 'Học liệu điện tử'},
    //       { property: 'og:title', content: this.mediaShareInfo.titleLink + ' - Hành trang số'},
    //       { property: 'og:site_name', content: 'Hành trang số'},
    //       { property: 'og:description', content: 'Học liệu điện tử'},
    //       { property: 'og:type', content: 'profile'},
    //       { property: 'og:url', content: this.linkShare },
    //       // { property: 'og:image', content: this.thumbnailUrl }
    //     ]
    //   }
    // },
    computed: {
      ...mapState('common', ['loading', 'mediaShareInfo', 'isShowModalShare', 'shareType', 'shareFacebook', 'shareMail', 'shareZalo', 'shareCopy']),
      authInfo () {
        return getAuth()
      }
    },
    watch: {
      isShowModalShare (newVal) {
        if (newVal) {
          this.$bvModal.show(ID_MODAL_SHARE)
        } else {
          this.$bvModal.hide(ID_MODAL_SHARE)
        }
      },

      mediaShareInfo (newVal) {
        let mediaFree = newVal.isShowFree === 1 ? `type_show=1` : ''
        let shareUTMParams = `shared=${window.location.origin}&${mediaFree}&utm_medium=social&utm_campaign=social`
        if (newVal && newVal.fullLink) {
          this.linkShare = newVal.fullLink + shareUTMParams
        } else if (newVal && newVal.pageLinksId) {
          let paramQuery = `?${shareUTMParams}`
         if (newVal.bookId) {
            paramQuery += `&book_page=${newVal.pageNo}&mediaId=${newVal.pageLinksId}&book_page_link=${newVal.bookPageLinkId}`
            this.linkShare = `${window.location.origin}/ebook/read/${newVal.bookSlug}-${newVal.bookId}${paramQuery}`
          } else {
            this.linkShare = `${window.location.origin}/thu-vien/hoc-lieu-dien-tu/${newVal.pageLinksId}${paramQuery}`
          }
          // this.titleShare = newVal.titleLink
          // this.linkShare = 'http://45.118.144.25:8091/thu-vien/hoc-lieu-dien-tu/22031?shared=http://45.118.144.25:8091&type_show=1&utm_medium=social&utm_campaign=social&utm_source=copy'
        }
      }
    },
    methods: {
      ...mapActions('common', ['setLoading', 'acToggleModalShareMedia', 'acSetMediaShareInfo', 'setToggleLoginForm']),

      handleShareMedia (type) {
        let self = this
        if ( self.authInfo.email === EMAIL_PUBLIC && (!self.mediaShareInfo.isShowFree || self.mediaShareInfo.isShowFree === 0) ) {
          self.setToggleLoginForm(true);
        } else if (self.linkShare) {
          let payload = {shareType: type, pageLinksId: self.mediaShareInfo.pageLinksId}
          switch (type) {
            case self.shareFacebook:
              self.linkShare += `&utm_source=facebook&title=${self.mediaShareInfo.titleLink}`
              self.setLoading(true)
              saveLogShareSocial(payload).then(res => {
                if (res) {
                  let codeParam = res.code ? `&code=${res.code}` : ''
                  setTimeout(() => {
                    self.popupWindowShare(`https://www.facebook.com/sharer/sharer.php?u=${self.linkShare}${codeParam}`, 'facebook-share', 580, 400)
                    self.handleOfModal()
                  }, 1000)
                  return false;
                }
              }).finally(() => self.setLoading(false))
              break;
            case self.shareMail:
              self.linkShare += `&utm_source=gmail`
              self.$bvModal.show(ID_MODAL_SHARE_MAIL)
              break;
            case self.shareZalo:
            // https://sp.zalo.me/plugins/share?dev=null&color=blue&oaid=579745863508352884&href=https%3A%2F%2Fdevelopers.zalo.me%2Fdocs%2Fsocial%2Fshare&layout=1&customize=false&callback=null&id=effd359f-6432-446f-a713-043b8ef138da&domain=developers.zalo.me&android=false&ios=false#!
              // window.open(`https://sp.zalo.me/plugins/share?href=${self.linkShare}`, 'sharer', 'toolbar=0,status=0,width=620,height=280');
              // window.open(`https://sp.zalo.me/plugins/share?oaid=579745863508352884&href=http://45.118.144.25:8091/sach-dien-tu/toan-1-tap-mot-407`, 'sharer', 'width=620,height=280');
              break;
            case self.shareCopy:
              if(!self.linkShare.includes(`&utm_source=copy`)) {
                self.linkShare += `&utm_source=copy`
              }
              setTimeout(() => {
                self.copyToClipboard(self.linkShare)
              }, 100)
              break;
          }
        }
      },

      popupWindowShare(myURL, title, myWidth, myHeight) {
        let left = (screen.width - myWidth) / 2;
        let top = (screen.height - myHeight) / 4;
        window.open(myURL, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + myWidth + ', height=' + myHeight + ', top=' + top + ', left=' + left);
      },

      handleOfModal () {
        this.acToggleModalShareMedia(false)
        this.acSetMediaShareInfo({})
        this.linkShare = ''
      },

      copyToClipboard (text) {
        var copyText = document.getElementById("link_share");

        copyText.select();
        copyText.setSelectionRange(0, 99999)
        let successful = document.execCommand("copy");
        successful && this.$toast.success('Copy thành công!')
        !successful && this.$toast.eror('Copy thất bại!')
        this.handleOfModal()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .share-list {
    @extend .display-flex-wrap;

    .item {
      width: 49%;
      @extend .display-flex-center;
      padding: 10px;
      @extend .primary-color-txt;
      @extend .font-sanpro-semibold;
      margin-bottom: 10px;
      border: 1px solid transparent;
      @extend .border-rd-4;

      [class^="icon-"], [class*=" icon-"] {
        @extend .font-size-22;
        @extend .primary-color;
        margin-right: 10px;
      }

      &:nth-child(odd) {
        margin-right: 2%;
      }

      &:hover {
        @extend .btn-gray;
        @extend .primary-color-txt;
      }
    }
  }

  #link_share {
    position: absolute;
    opacity: 0;
    top: 0;
    z-index: -1;
  }
</style>